export function serializeImage(obj, shouldNotHaveAlt) {
    if (!obj) {
        return null;
    }

    if (!obj?.file) {
        return null;
    }

    const alt = obj.altText || obj.title || undefined;
    const credits = obj.credits || undefined;
    const caption = obj.caption || undefined;
    const width = obj.width || undefined;
    const height = obj.height || undefined;
    const title = obj.title || undefined;
    const focal = obj.focal || undefined;
    const renditions = obj.renditions || undefined;

    return {
        src: obj.url || obj.src,
        alt: shouldNotHaveAlt ? alt : '',
        credits: credits,
        width: width,
        height: height,
        title: title,
        focal: focal,
        caption: caption,
        renditions: renditions,
    };
}
